<template>
    <div class="row">
      <loading
        :active.sync="loader.isLoading"
        :can-cancel="loader.canCancel"
        :is-full-page="loader.fullPage"
        :color="loader.color"
        :height="loader.height"
        :width="loader.width"
        :background-color="loader.backgroundColor"
        :loader="loader.loader">
      </loading>
      <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Finance</h5>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <div class="form-inline ml-auto">
                  <div class="button-group">
                    <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addCost">
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                    <!-- <select class="btn btn-outline-primary btn-sm mr-1" v-model="categoryFilter">
                      <option value="">-- Category --</option>
                      <option v-for="c in costCategoryList" :key="c.id" :value="c.id">{{ c.name }}</option>
                    </select> -->
                    <select class="btn btn-outline-primary btn-sm" v-model="groupFilter" :disabled="authUser.permissions['can-allow-group']">
                      <option value="">-- Group --</option>
                      <option value="owner">Owner</option>
                      <option value="member">Member</option>
                    </select>
                    rows:
                    <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                      <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                    </select>
                    <span class="mr-1">
                      Total rows: <b>{{ rowsTotal }}</b>
                    </span>
                    <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshCost"></date-picker>
                    <button type="button" class="btn btn-sm  btn-soft-primary waves-light waves-effect ml-1" @click="refreshCost">
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn btn-sm  btn-soft-primary waves-light waves-effect ml-1" @click="getReport">
                      REPORT KAS
                    </button>
                    <button type="button" class="btn btn-sm  btn-soft-primary waves-light waves-effect ml-1" @click="getReportOmzet">
                      REPORT OMZET
                    </button>
                </div>

                <div class="form-group mx-sm-3 mb-2">
                    <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                </div>
                <span class="mr-1">
                  page:
                  <select v-model="currentPage">
                    <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                  </select>
                  / {{ pageLength }}
                </span>
                <nav aria-label="Page navigation example" class="pull-right">
                    <ul class="pagination">
                        <li class="page-item">
                            <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                <i class="fa fa-angle-left" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li class="page-item">
                            <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                            </a>
                        </li>
                    </ul>
                </nav>
              </div>
                <table class="table table-item mb-0 table-sm table-striped">
                    <thead>
                        <tr>
                            <th>
                              <label class="form-checkbox">
                                <input type="checkbox" v-model="selectAll" @click="select">
                                <i class="form-icon"></i>
                              </label>
                            </th>
                            <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                {{ t.name }}
                                <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                            <th @click="sortTable('amount_in')" class="text-right">
                              In
                            </th>
                            <th @click="sortTable('amount_out')" class="text-right">
                              Out
                            </th>
                            <th class="text-right">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filterData.length < 1">
                        <td colspan="13" style="text-align: center;"><i>No Data</i></td>
                      </tr>
                      <tr v-for="u in filterData" v-bind:key="u.id" @click="editCost(u.id)" style="cursor: pointer">
                        <td>
                          <label class="form-checkbox">
                            <input type="checkbox" :value="u.id" v-model="selected">
                            <i class="form-icon"></i>
                          </label>
                        </td>
                        <td><b>{{ u.cost_no }}</b></td>
                        <td>{{ u.cash_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td>
                          {{ u.type.name }}
                        </td>
                        <td>
                          <span class="badge badge-warning" v-if="u.category.name === 'cash'">{{ u.category.name }}</span>
                          <span class="badge badge-success" v-else>{{ u.category.name }}</span>
                        </td>
                        <td>
                          <span v-if="u.customer">{{ u.customer.name }}</span>
                          <span v-else>-</span>
                        </td>
                        <td>
                          <span v-if="u.vendor">{{ u.vendor.name }}</span>
                          <span v-else>-</span>
                        </td>
                        <td>
                          {{ u.branch_no }}
                        </td>
                        <td>
                          <span v-if="u.bank">{{ u.bank.name }}</span>
                          <span v-else>-</span>
                        </td>
                        <td>{{ u.ref_no }}</td>
                        <td class="text-right">{{ u.amount_in | currency }}</td>
                        <td class="text-right">{{ u.amount_out | currency }}</td>
                        <td class="text-right">
                          {{ u.amount_in - u.amount_out | currency }}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td  colspan="11" class="text-right">
                          <h5><b>{{ totalIn | currency }}</b></h5>
                        </td>
                        <td class="text-right">
                          <h5><b>{{ totalOut | currency }}</b></h5>
                        </td>
                        <td class="text-right">
                          <h5><b>{{ totalIn - totalOut | currency }}</b></h5>
                        </td>
                      </tr>
                    </tfoot>
                </table>
              </div>
            </div>
          </div>
      </div>
      <!-- <pre>{{ categoryFilter }}</pre>
      <pre>{{ authUser.permissions['cost-allow-group'] }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { costPrintReportUrl, costUrl, getHeader } from '../../config'
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'SalesList',
  components: {
    DatePicker,
    Loading
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      categoryFilter: '',
      groupFilter: 'member',
      startDate: [date1, date2],
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'No.',
        prop: 'cost_no'
      }, {
        name: 'Date',
        prop: 'cash_date'
      }, {
        name: 'Type',
        prop: 'type.name'
      }, {
        name: 'Category',
        prop: 'category.name'
      }, {
        name: 'customer',
        prop: 'customer_no'
      }, {
        name: 'Vendor',
        prop: 'vendor_no'
      }, {
        name: 'Branch',
        prop: 'branch.name'
      }, {
        name: 'Bank',
        prop: 'bank.name'
      }, {
        name: 'Ref No',
        prop: 'ref_no'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.$store.dispatch('getRowTable')
    this.refreshCost()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      authUser: state => state.users.authUser,
      costCategoryList: state => state.costs.costCategoryList
    }),
    totalIn: function () {
      var out = this.filterData.filter(d => d.method === 'in')
      var sum = 0
      for (let i = 0; i < out.length; i++) {
        sum += parseFloat(out[i].amount)
      }
      return sum
    },
    totalOut: function () {
      var out = this.filterData.filter(d => d.method === 'out')
      var sum = 0
      for (let i = 0; i < out.length; i++) {
        sum += parseFloat(out[i].amount)
      }
      return sum
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      }).filter(d => d.group_id === this.groupFilter)
    }
  },
  methods: {
    getReport: function () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      window.open(costPrintReportUrl + '?begin=' + begin + '&end=' + end, '_blank')
    },
    getReportOmzet: function () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      window.open(costPrintReportUrl + '/product?begin=' + begin + '&end=' + end, '_blank')
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editCost (id) {
      axios.get(costUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('editCost', response.data.data)
        })
        .catch(response => {
          this.$swal(
            'Error!!!',
            response,
            'error'
          )
        })
    },
    addCost () {
      this.$emit('newCost', true)
    },
    refreshCost () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = costUrl + '?begin=' + begin + '&end=' + end
      console.log(url)
      axios.get(url, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response)
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.currentPage = 1
          this.searchQuery = ''
        })
        .catch(error => {
          this.loader.isLoading = false
          if (error === 'Error: Network Error') {
            window.localStorage.removeItem('authUser')
            this.$router.push({ name: 'login' })
          } else if (error.response.data.message === 'This action is unauthorized.') {
            window.localStorage.removeItem('authUser')
            this.$router.push({ name: 'login' })
          }
        })
    }
  }
}
</script>
